import React from 'react';
import styles from './index.scss';
import { Icon } from 'antd';

export default class ImagePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: '',
      imageVisible: false,
      imgScale: 1,
      imgTransform: '',
      imgCurrent: 0,
      currentIndex: 0,
    };
  }

  closeImagePreviewModel = () => {
    this.setState({
      imageVisible: false,
      imgScale: 1,
      imgTransform: '',
      imgCurrent: 0,
    });
  };

  //放大
  imgToBigger = e => {
    e.stopPropagation();
    const { imgScale } = this.state;
    if (imgScale < 4) {
      const a = imgScale + 0.5;
      this.setState({ imgScale: a });
    }
  };
  //缩小
  imgToSmaller = e => {
    e.stopPropagation();
    const { imgScale } = this.state;
    if (imgScale > 1) {
      const a = imgScale - 0.5;
      this.setState({ imgScale: a });
    }
  };
  //左旋转
  imgToLeftRoll = e => {
    e.stopPropagation();
    const a = (this.state.imgCurrent - 90) % 360;
    this.setState({ imgTransform: 'rotate(' + a + 'deg)', imgCurrent: a });
  };
  //右旋转
  imgToRightRoll = e => {
    e.stopPropagation();
    const a = (this.state.imgCurrent + 90) % 360;
    this.setState({ imgTransform: 'rotate(' + a + 'deg)', imgCurrent: a });
  };

  // 点击图片放大
  clickImg = index => {
    const { imgList, imgKey } = this.props;
    this.setState({
      currentIndex: index,
      imageVisible: true,
      imgSrc: imgKey ? imgList[index][imgKey] : imgList[index],
    });
  };

  // 左右查看图片
  leftOrRightImg = (e, type) => {
    e.stopPropagation();
    const { currentIndex } = this.state;
    const { imgList, imgKey } = this.props;
    let nextIndex = currentIndex;
    if (type === 'left' && currentIndex !== 0) {
      nextIndex -= 1;
    } else if (type === 'right' && currentIndex !== imgList.length - 1) {
      nextIndex += 1;
    }
    this.setState({
      currentIndex: nextIndex,
      imgSrc: imgKey ? imgList[nextIndex][imgKey] : imgList[nextIndex],
    });
  };

  render = () => {
    const { imgScale, imgSrc, imgTransform, imageVisible, currentIndex } = this.state;
    const { imgList, width, height, imgKey } = this.props;
    return (
      <>
        {/* 默认显示的图片 */}
        <div>
          {imgList.map((item, index) => (
            <img
              key={item[imgKey]}
              style={{ marginRight: 10 }}
              onClick={() => this.clickImg(index)}
              src={imgKey ? item[imgKey] : item}
              width={width || 100}
              height={height || 100}
            />
          ))}
        </div>
        <div
          onClick={this.closeImagePreviewModel}
          className={styles.modalImg}
          style={{ display: imageVisible ? 'flex' : 'none' }}>
          <div className={styles.imgPreviewWrapper}>
            <div
              onClick={e => this.leftOrRightImg(e, 'left')}
              className={[
                styles.imgPreviewSwitchLeft,
                currentIndex === 0 ? styles.imgPreviewSwitchLeftDisabled : '',
              ].join(' ')}>
              <span role="img" aria-label="left" className="anticon anticon-left">
                <Icon type="left" />
              </span>
            </div>
            <div
              onClick={e => this.leftOrRightImg(e, 'right')}
              className={[
                styles.imgPreviewSwitchRight,
                currentIndex === imgList.length - 1 ? styles.imgPreviewSwitchRightDisabled : '',
              ].join(' ')}>
              <span role="img" aria-label="left" className="anticon anticon-right">
                <Icon type="right" />
              </span>
            </div>
            <ul className={styles.imgPreviewOperations}>
              {imgList.length > 1 && (
                <li className={styles.imgPreviewProgress}>
                  {currentIndex + 1} / {imgList.length}
                </li>
              )}
              <li
                className={[styles.imgPreviewOperation, styles.imgPreviewOperationColse].join(' ')}>
                <Icon type="close" />
              </li>
              <li
                onClick={e => this.imgToBigger(e)}
                className={[
                  styles.imgPreviewOperation,
                  imgScale === 4 ? styles.imgPreviewOperationDisabled : '',
                ].join(' ')}>
                <Icon type="zoom-in" />
              </li>
              <li
                onClick={e => this.imgToSmaller(e)}
                className={[
                  styles.imgPreviewOperation,
                  imgScale === 1 ? styles.imgPreviewOperationDisabled : '',
                ].join(' ')}>
                <Icon type="zoom-out" />
              </li>
              <li
                onClick={e => this.imgToRightRoll(e)}
                className={[styles.imgPreviewOperation].join(' ')}>
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="rotate-right"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true">
                  <defs>
                    <style></style>
                  </defs>
                  <path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"></path>
                  <path d="M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"></path>
                </svg>
              </li>
              <li
                onClick={e => this.imgToLeftRoll(e)}
                className={[styles.imgPreviewOperation].join(' ')}>
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="rotate-left"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true">
                  <defs>
                    <style></style>
                  </defs>
                  <path d="M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"></path>
                  <path d="M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"></path>
                </svg>
              </li>
            </ul>
          </div>
          <img
            src={imgSrc}
            className={styles.imgName}
            style={{
              transform: `scale(${imgScale}) ${imgTransform}`,
            }}
          />
        </div>
      </>
    );
  };
}
